"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckDependenciesPlugin = exports.CheckDependenciesEntityDialog = void 0;
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const entity_core_1 = require("@sierralabs/entity-core");
const entity_ui_1 = require("@sierralabs/entity-ui");
const useCheckDependencies_1 = require("../../hooks/useCheckDependencies");
const useWorkflowItem_1 = require("../../hooks/useWorkflowItem");
const useWorkflowStatuses_1 = require("../../hooks/useWorkflowStatuses");
const useFindTaskTypeById_1 = require("../../task-types/hooks/useFindTaskTypeById");
const useFindTaskTypes_1 = require("../../task-types/hooks/useFindTaskTypes");
const TaskTypePicker_1 = __importDefault(require("../../task-types/pickers/TaskTypePicker"));
function displayStatuses(statuses = [], wrap = true, defaultValue = 'Any') {
    const allStatuses = statuses.join(', ');
    const status = wrap && statuses.length > 1 ? `(${allStatuses})` : allStatuses;
    return status || defaultValue;
}
function displayEntityProperties(properties) {
    return properties.map((property, index) => {
        var _a;
        return (react_1.default.createElement(react_1.Fragment, { key: index },
            react_1.default.createElement("strong", null, ((_a = property.relation) === null || _a === void 0 ? void 0 : _a.displayName) || '?'),
            index < properties.length - 1 && ' -> '));
    });
}
const CheckDependenciesConfigurator = props => {
    var _a, _b, _c, _d;
    const { taskTypeId, condition, onChange } = props;
    const [open, setOpen] = (0, react_1.useState)(false);
    const [updateIndex, setUpdateIndex] = (0, react_1.useState)(-1);
    const [removeIndex, setRemoveIndex] = (0, react_1.useState)(-1);
    if (!condition.params) {
        condition.params = {};
    }
    const params = condition.params;
    const { entities } = (0, entity_ui_1.useEntityContext)();
    const { data: taskType, get } = (0, useFindTaskTypeById_1.useFindTaskTypeById)(taskTypeId || 0);
    // entity schema of current Workflow
    const schema = taskType
        ? entities === null || entities === void 0 ? void 0 : entities.find(schema => {
            return taskType.entityId
                ? schema.id === taskType.entityId
                : schema.tableName === taskType.entityTable;
        })
        : undefined;
    const getDisplayName = (dependency, includeStatus = false) => {
        if (!dependency) {
            return '?';
        }
        const properties = (0, entity_core_1.getEntityProperties)([dependency.propertyName].concat(dependency.relations || []), schema, entities || []);
        const property = properties
            .map(property => {
            var _a;
            return ((_a = property.relation) === null || _a === void 0 ? void 0 : _a.displayName) || property.propertyName || '?';
        })
            .join(' -> ');
        const entity = (schema === null || schema === void 0 ? void 0 : schema.displayName) || '?';
        const displayName = `${entity} -> ${property}`;
        const status = displayStatuses(dependency.statuses);
        return includeStatus ? `${displayName} -> ${status}` : displayName;
    };
    (0, react_1.useEffect)(() => {
        get();
    }, [get]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.TableContainer, null,
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, null, "Name"),
                        react_1.default.createElement(core_1.TableCell, null, "Dependency"),
                        react_1.default.createElement(core_1.TableCell, null, "Required State/s"),
                        react_1.default.createElement(core_1.TableCell, null))),
                react_1.default.createElement(core_1.TableBody, null,
                    !((_a = params.dependencies) === null || _a === void 0 ? void 0 : _a.length) && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 4 }, "No dependencies."))), (_b = params.dependencies) === null || _b === void 0 ? void 0 :
                    _b.map((dependency, index) => {
                        const relations = [
                            dependency.propertyName,
                            ...(dependency.relations || [])
                        ];
                        const propertyName = relations[relations.length - 1];
                        return (react_1.default.createElement(core_1.TableRow, { key: `${dependency.name}-${propertyName}-${index}` },
                            react_1.default.createElement(core_ui_1.WrappedTableCell, null, dependency.name || (0, lodash_1.startCase)(propertyName)),
                            react_1.default.createElement(core_ui_1.WrappedTableCell, null,
                                getDisplayName(dependency),
                                dependency.optional && (react_1.default.createElement(react_1.default.Fragment, null,
                                    ' ',
                                    react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary', style: { display: 'inline-block' } }, "(optional)")))),
                            react_1.default.createElement(core_ui_1.WrappedTableCell, null, displayStatuses(dependency.statuses, false)),
                            react_1.default.createElement(core_1.TableCell, { padding: 'checkbox' },
                                react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: () => setUpdateIndex(index) },
                                    react_1.default.createElement(icons_1.Edit, null)),
                                react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: () => setRemoveIndex(index) },
                                    react_1.default.createElement(icons_1.Close, null)))));
                    })))),
        react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(core_1.Button, { variant: 'outlined', disabled: !schema, startIcon: react_1.default.createElement(icons_1.Add, null), onClick: () => setOpen(true) }, "Add Dependency")),
        !schema && (react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(lab_1.Alert, { severity: 'error' }, "No schema found for this Workflow."))),
        schema && (react_1.default.createElement(exports.CheckDependenciesEntityDialog, { schema: schema, open: open || updateIndex > -1, dependency: (_c = params.dependencies) === null || _c === void 0 ? void 0 : _c[updateIndex], title: updateIndex > -1 ? 'Update Dependency' : 'Add Dependency', onCancel: () => {
                setOpen(false);
                setUpdateIndex(-1);
            }, onSubmit: dependency => {
                params.entity = { id: schema.id, table: schema.tableName };
                if (!params.dependencies) {
                    params.dependencies = [];
                }
                if (updateIndex > -1) {
                    params.dependencies.splice(updateIndex, 1, dependency);
                }
                else {
                    params.dependencies.push(dependency);
                }
                setOpen(false);
                setUpdateIndex(-1);
                onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
            } })),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { confirmLabel: 'Remove', open: removeIndex > -1, title: 'Remove Dependency', message: `Are you sure you want to remove ${getDisplayName((_d = params.dependencies) === null || _d === void 0 ? void 0 : _d[removeIndex], true)} dependency?`, onCancel: () => setRemoveIndex(-1), onConfirm: () => {
                if (!params.dependencies) {
                    params.dependencies = [];
                }
                if (removeIndex > -1) {
                    params.dependencies.splice(removeIndex, 1);
                }
                setRemoveIndex(-1);
                onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
            } })));
};
const StyledBox = (0, styled_components_1.default)(core_1.Box) `
  .grid-field {
    flex: 1;
  }
  .grid-action {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
  }
`;
const CheckDependenciesEntityDialog = props => {
    var _a;
    const { open, title, schema, dependency: dependencyProp, onCancel, onSubmit } = props;
    const [dependency, setDependency] = (0, react_1.useState)(dependencyProp || { relations: [], statuses: [] });
    const { entities } = (0, entity_ui_1.useEntityContext)();
    const { data, isLoading: isFinding, findTaskTypes } = (0, useFindTaskTypes_1.useFindTaskTypes)();
    const { workflow } = (0, useWorkflowItem_1.useWorkflowItem)((0, react_1.useMemo)(() => {
        return { taskTypeId: dependency.taskTypeId };
    }, [dependency.taskTypeId])) || {};
    const taskTypes = (0, react_1.useMemo)(() => data || [], [data]);
    const statuses = (0, useWorkflowStatuses_1.useWorkflowStatuses)(workflow);
    const isValidStatus = (0, react_1.useMemo)(() => {
        return (Array.isArray(dependency.statuses) &&
            // allow optional statuses
            // dependency.statuses.length > 0 &&
            dependency.statuses.every(status => statuses.includes(status)) &&
            (!dependency.relations ||
                dependency.relations.every(relation => !!relation)));
    }, [dependency, statuses]);
    const properties = (0, react_1.useMemo)(() => {
        return (0, entity_core_1.getEntityProperties)([dependency.propertyName].concat(dependency.relations || []), schema, entities || []);
    }, [dependency, schema, entities]);
    // get last property.relation
    const relation = (0, react_1.useMemo)(() => {
        var _a;
        return (_a = properties[properties.length - 1]) === null || _a === void 0 ? void 0 : _a.relationSchema;
    }, [properties]);
    const entityId = relation === null || relation === void 0 ? void 0 : relation.id;
    const entityTable = relation === null || relation === void 0 ? void 0 : relation.tableName;
    const entityDependency = (0, react_1.useMemo)(() => {
        const { name, statuses, propertyName, taskTypeId, optional, relations = [] } = dependency;
        if (isValidStatus && statuses && propertyName && taskTypeId) {
            return {
                name,
                statuses,
                propertyName,
                taskTypeId,
                relations,
                optional
            };
        }
    }, [dependency, isValidStatus]);
    (0, react_1.useEffect)(() => {
        if (entityId || entityTable) {
            findTaskTypes({ entityId, entityTable });
        }
    }, [entityId, entityTable, findTaskTypes]);
    // clear state
    (0, react_1.useEffect)(() => {
        if (!open) {
            setDependency({ relations: [], statuses: [] });
        }
    }, [open]);
    (0, react_1.useEffect)(() => {
        dependencyProp && setDependency(dependencyProp);
    }, [dependencyProp]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, open: open, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, title),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.Box, null,
                react_1.default.createElement(core_1.TextField, { fullWidth: true, variant: 'outlined', label: 'Display Name', placeholder: 'Enter the display name of the Dependency', value: dependency.name || '', onChange: event => {
                        setDependency(dependency => {
                            return Object.assign(Object.assign({}, dependency), { name: event.target.value });
                        });
                    } })),
            react_1.default.createElement(core_1.Box, { mt: 2 },
                react_1.default.createElement(entity_ui_1.EntitySchemaPicker, { disabled: true, value: schema.name, textFieldProps: { label: 'Workflow Entity' } })),
            properties.map((property, index) => {
                var _a;
                return (react_1.default.createElement(StyledBox, { mt: 2, key: index },
                    react_1.default.createElement(core_1.Grid, { container: true, spacing: 0 },
                        react_1.default.createElement(core_1.Grid, { item: true, className: 'grid-field' },
                            react_1.default.createElement(entity_ui_1.EntitySchemaRelationPicker, { schema: property.schema, value: property.propertyName, textFieldProps: {
                                    label: index === 0 ? 'Dependent Entity' : 'Entity Relation',
                                    placeholder: `Select a Relationship from ${((_a = property.schema) === null || _a === void 0 ? void 0 : _a.displayName) || '?'}`
                                }, onChange: relation => {
                                    const propertyName = relation === null || relation === void 0 ? void 0 : relation.propertyName;
                                    setDependency(dependency => {
                                        dependency = Object.assign({}, dependency);
                                        if (!dependency.relations) {
                                            dependency.relations = [];
                                        }
                                        if (index === 0) {
                                            dependency.propertyName = propertyName;
                                        }
                                        else {
                                            dependency.relations[index - 1] = propertyName || '';
                                        }
                                        if (!propertyName) {
                                            dependency.statuses = [];
                                            dependency.taskTypeId = undefined;
                                            // unset all subsequent relations
                                            dependency.relations.splice(index);
                                        }
                                        return dependency;
                                    });
                                } })),
                        index > 0 && (react_1.default.createElement(core_1.Grid, { item: true, className: 'grid-action' },
                            react_1.default.createElement(core_1.IconButton, { onClick: () => {
                                    setDependency(dependency => {
                                        var _a;
                                        dependency = Object.assign(Object.assign({}, dependency), { statuses: [], taskTypeId: undefined });
                                        (_a = dependency.relations) === null || _a === void 0 ? void 0 : _a.splice(index - 1);
                                        return dependency;
                                    });
                                } },
                                react_1.default.createElement(icons_1.Close, null)))))));
            }),
            react_1.default.createElement(core_1.Box, { mt: 2 },
                react_1.default.createElement(core_1.Button, { fullWidth: true, variant: 'outlined', startIcon: react_1.default.createElement(icons_1.Add, null), 
                    // disabled if no selected for last property
                    disabled: !properties[properties.length - 1].propertyName, onClick: () => {
                        setDependency(dependency => {
                            dependency = Object.assign(Object.assign({}, dependency), { statuses: [], taskTypeId: undefined });
                            if (!dependency.relations) {
                                dependency.relations = [];
                            }
                            dependency.relations.push('');
                            return dependency;
                        });
                    } }, "Add Relation")),
            react_1.default.createElement(core_1.Box, { mt: 2 },
                react_1.default.createElement(TaskTypePicker_1.default, { options: taskTypes, disabled: !relation, isLoading: isFinding, value: dependency.taskTypeId, textFieldProps: {
                        label: 'Entity Task Type',
                        placeholder: 'Select the Task Type of Entity'
                    }, onChange: taskType => {
                        // add display name if not set
                        const taskTypeLabel = taskType
                            ? `${taskType.label} (${taskType.prefix})`
                            : '';
                        setDependency(dependency => {
                            dependency = Object.assign(Object.assign({}, dependency), { taskTypeId: taskType === null || taskType === void 0 ? void 0 : taskType.id, name: dependency.name || taskTypeLabel });
                            if (!dependency.taskTypeId) {
                                dependency.statuses = [];
                            }
                            return dependency;
                        });
                    } })),
            react_1.default.createElement(core_1.Box, { mt: 2 },
                react_1.default.createElement(lab_1.Autocomplete, { multiple: true, options: statuses, value: dependency.statuses || [], disabled: !dependency.taskTypeId, onChange: (_, statuses) => {
                        setDependency(dependency => (Object.assign(Object.assign({}, dependency), { statuses })));
                    }, renderInput: params => {
                        const error = !isValidStatus &&
                            Array.isArray(dependency.statuses) &&
                            dependency.statuses.length > 0;
                        return (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, variant: 'outlined', label: 'Transition States', placeholder: `Select the statuses for ${workflow ? workflow.stateNode.name : 'the Workflow'}`, error: error, helperText: error
                                ? 'Invalid state found that is not part of the selected Workflow.'
                                : undefined })));
                    } })),
            react_1.default.createElement(core_1.Box, { mt: 2 },
                react_1.default.createElement(core_1.FormControlLabel, { label: 'Optional Dependency', control: react_1.default.createElement(core_1.Checkbox, { color: 'primary', checked: dependency.optional || false, onChange: (_, checked) => {
                            setDependency(dependency => {
                                return Object.assign(Object.assign({}, dependency), { optional: checked });
                            });
                        } }) }),
                react_1.default.createElement(core_1.FormHelperText, null,
                    "When checked, ",
                    react_1.default.createElement("strong", null, "optional dependencies"),
                    " will allow the entity to transition when there are no dependencies to check. (e.g. No linked documents will allow transition)")),
            react_1.default.createElement(core_1.Collapse, { in: !!(relation && workflow && entityDependency) },
                react_1.default.createElement(core_1.Box, { mt: 2 },
                    react_1.default.createElement(lab_1.Alert, { severity: 'info' },
                        "This condition will transition the entity (",
                        react_1.default.createElement("strong", null, schema.displayName),
                        ") when its dependencies (",
                        displayEntityProperties(properties),
                        ") are in the",
                        ' ',
                        react_1.default.createElement("strong", null, (workflow === null || workflow === void 0 ? void 0 : workflow.stateNode.name) || '?'),
                        " ",
                        '->',
                        ' ',
                        react_1.default.createElement("strong", null, displayStatuses(entityDependency === null || entityDependency === void 0 ? void 0 : entityDependency.statuses)),
                        ' ',
                        (((_a = entityDependency === null || entityDependency === void 0 ? void 0 : entityDependency.statuses) === null || _a === void 0 ? void 0 : _a.length) || 0) > 1
                            ? `states`
                            : 'state',
                        ".")))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Cancel"),
            react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', disabled: !entityDependency, onClick: () => {
                    if (entityDependency) {
                        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(entityDependency);
                    }
                } }, "Save"))));
};
exports.CheckDependenciesEntityDialog = CheckDependenciesEntityDialog;
const CheckDependenciesDisplay = () => {
    return react_1.default.createElement(react_1.default.Fragment, null, "Check Dependencies");
};
const StyledTableCell = (0, styled_components_1.default)(core_1.TableCell) `
  .MuiSvgIcon-root {
    &.success {
      color: ${props => props.theme.palette.success.main};
    }
    &.info {
      color: ${props => props.theme.palette.info.main};
    }
    &.error {
      color: ${props => props.theme.palette.error.main};
    }
    &.warn {
      color: ${props => props.theme.palette.warning.main};
    }
  }
`;
const CheckDependenciesDialog = props => {
    const { state, params, onCancel, onConfirm } = props;
    const { data, isLoading, error, checkDependencies } = (0, useCheckDependencies_1.useCheckDependencies)(state.context.task.id || 0);
    const success = !!(data === null || data === void 0 ? void 0 : data.success);
    const getLabelAndIcon = (result) => {
        const [label, color, StatusIcon] = result.none && !(result.optional && result.total === 0)
            ? ['None', 'error', icons_1.HighlightOff]
            : result.partial
                ? ['Partial', 'warn', icons_1.OfflinePinOutlined]
                : result.success
                    ? ['All', 'success', icons_1.CheckCircleOutline]
                    : ['None (optional)', 'info', icons_1.CheckCircleOutline];
        return { label, icon: react_1.default.createElement(StatusIcon, { className: color }) };
    };
    (0, react_1.useEffect)(() => {
        checkDependencies(params);
    }, [params, checkDependencies]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, open: true, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, isLoading ? 'Checking Dependencies' : 'Check Dependencies'),
        react_1.default.createElement(core_1.DialogContent, { style: { padding: 0 } },
            isLoading && (react_1.default.createElement(core_1.Box, { mx: 3, my: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' },
                react_1.default.createElement(core_1.CircularProgress, null))),
            data && !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Box, { mx: 3 },
                    react_1.default.createElement(core_1.DialogContentText, null,
                        "All dependencies need to be in their",
                        ' ',
                        react_1.default.createElement("strong", null, "Required State/s"),
                        " state to be able to transition this item.")),
                react_1.default.createElement(core_1.Box, null,
                    react_1.default.createElement(core_1.TableContainer, null,
                        react_1.default.createElement(core_1.Table, null,
                            react_1.default.createElement(core_1.TableHead, null,
                                react_1.default.createElement(core_1.TableRow, null,
                                    react_1.default.createElement(core_1.TableCell, null, "Dependency"),
                                    react_1.default.createElement(core_1.TableCell, null, "Required State/s"),
                                    react_1.default.createElement(core_1.TableCell, null, "Valid Items"),
                                    react_1.default.createElement(core_1.TableCell, null, "Status"))),
                            react_1.default.createElement(core_1.TableBody, null, data.dependencies.map((result, index) => {
                                var _a;
                                const dependency = (_a = params.dependencies) === null || _a === void 0 ? void 0 : _a[index];
                                const { label, icon } = getLabelAndIcon(result);
                                return (react_1.default.createElement(core_1.TableRow, { key: index },
                                    react_1.default.createElement(core_ui_1.WrappedTableCell, null,
                                        result.name,
                                        result.optional && (react_1.default.createElement(react_1.default.Fragment, null,
                                            ' ',
                                            react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary', style: { display: 'inline-block' } }, "(optional)")))),
                                    react_1.default.createElement(core_ui_1.WrappedTableCell, null, displayStatuses(dependency === null || dependency === void 0 ? void 0 : dependency.statuses, false)),
                                    react_1.default.createElement(core_ui_1.WrappedTableCell, null,
                                        react_1.default.createElement("strong", null, result.valid),
                                        " of",
                                        ' ',
                                        react_1.default.createElement("strong", null, result.total)),
                                    react_1.default.createElement(StyledTableCell, null,
                                        react_1.default.createElement(core_1.Tooltip, { arrow: true, title: label }, icon))));
                            }))))))),
            react_1.default.createElement(core_1.Collapse, { in: success },
                react_1.default.createElement(core_1.Box, { mt: 2, mx: 3 },
                    react_1.default.createElement(lab_1.Alert, { severity: 'success' }, "All dependency checks passed!"))),
            react_1.default.createElement(core_1.Collapse, { in: !isLoading && !!error },
                react_1.default.createElement(core_1.Box, { mt: 2, mx: 3 },
                    react_1.default.createElement(lab_1.Alert, { severity: 'error' }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.')))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { disabled: isLoading, onClick: onCancel }, success ? 'Cancel' : 'Close'),
            success && (react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', disabled: isLoading, onClick: onConfirm }, "Confirm")))));
};
exports.CheckDependenciesPlugin = {
    type: 'check-dependencies',
    label: 'Check Dependencies',
    configurator: CheckDependenciesConfigurator,
    display: CheckDependenciesDisplay,
    validate: (condition) => {
        const params = condition.params;
        return !!((params === null || params === void 0 ? void 0 : params.entity) &&
            (params.entity.id || params.entity.table) &&
            Array.isArray(params.dependencies) &&
            params.dependencies.length > 0);
    },
    validateImport: () => {
        return {
            severity: 'warning',
            message: 'References may differ between environments.'
        };
    },
    guard: (state, params, render) => {
        if (state.isSimulation)
            return true;
        console.log('guards: check-dependencies', state, params);
        return new Promise(resolve => {
            render === null || render === void 0 ? void 0 : render(react_1.default.createElement(CheckDependenciesDialog, { state: state, params: params, onCancel: () => {
                    render === null || render === void 0 ? void 0 : render(undefined);
                    resolve(false);
                }, onConfirm: () => {
                    render === null || render === void 0 ? void 0 : render(undefined);
                    resolve(true);
                } }));
        });
    }
};
//# sourceMappingURL=CheckDependenciesPlugin.js.map